package com.anjuros.website.templates.template10.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template10.components.Template10Eyebrow
import com.anjuros.website.templates.template10.components.Template10Reveal
import com.anjuros.website.templates.template10.components.Template10Title
import com.anjuros.website.templates.template10.components.Template10YouTube
import com.anjuros.website.templates.template10.components.template10BodyFont
import com.anjuros.website.templates.template10.modules.Template10Section
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.styles.Template10ContainerStyle
import com.anjuros.website.templates.template10.styles.Template10SectionPaddingStyle
import com.anjuros.website.templates.template10.util.ResKey
import com.anjuros.website.templates.template10.util.Template10Constants
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template10VideosSection() {
    Column(
        modifier = Template10SectionPaddingStyle.toModifier()
            .id(Template10Section.Videos.id)
            .fillMaxWidth()
            .backgroundColor(Template10Theme.Ink.rgb),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Template10ContainerStyle.toModifier().gap(48.px)
        ) {
            Template10Reveal(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .flexWrap(FlexWrap.Wrap)
                        .gap(24.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.Bottom
                ) {
                    Column(modifier = Modifier.gap(14.px)) {
                        Template10Eyebrow(
                            text = ResKey.TEMPLATE10_SECTION3,
                            color = Template10Theme.Coral.rgb
                        )
                        Template10Title(
                            text = ResKey.TEMPLATE10_VIDEOS_TITLE,
                            color = Template10Theme.Paper.rgb
                        )
                    }
                    P(
                        attrs = Modifier
                            .margin(0.px)
                            .maxWidth(420.px)
                            .template10BodyFont()
                            .fontSize(17.px)
                            .lineHeight(1.6)
                            .color(Template10Theme.StoneLight.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.TEMPLATE10_VIDEOS_DESC))
                    }
                }
            }

            // featured video
            Template10Reveal(modifier = Modifier.fillMaxWidth()) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(12.px)
                        .overflow(Overflow.Hidden)
                        .backgroundColor(Template10Theme.InkCard.rgb)
                ) {
                    Template10YouTube(videoId = Template10Constants.VIDEOS.first())
                }
            }

            // three smaller clips
            SimpleGrid(
                numColumns = numColumns(base = 1, md = 3),
                modifier = Modifier.fillMaxWidth().gap(24.px)
            ) {
                Template10Constants.VIDEOS.drop(1).forEachIndexed { index, videoId ->
                    Template10Reveal(
                        modifier = Modifier.fillMaxWidth(),
                        delayMs = index * 150
                    ) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .borderRadius(10.px)
                                .overflow(Overflow.Hidden)
                                .backgroundColor(Template10Theme.InkCard.rgb)
                        ) {
                            Template10YouTube(videoId = videoId)
                        }
                    }
                }
            }
        }
    }
}
